import React, { useState } from "react";
import useForm from '../../../../hooks/useForm';
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'
import useDataAttendees from "../../../../dataHooks/useDataAttendees";
import { getClientSubdomain } from '../../../../utils'
import useSnackbar from "../../../../hooks/useSnackbar";

export default ({
  attendee = {},
  eventId,
  onClose,
  onSuccess,
}) => {
  const clientSubdomain = getClientSubdomain()
    
  const isStarSubdomain = (clientSubdomain === 'star')

  const { newMessage } = useSnackbar()

  const {
    addNewAttendee,
    updateAttendee,
  } = useDataAttendees()

  const requiredFields = ['name', 'email']
  const optionalFields = []
  if (isStarSubdomain) {
    requiredFields.push('district')
    optionalFields.push('date')
  }

  const formSchema = {
    requiredFields,
    optionalFields,
    initData: attendee
  };

  const formData = useForm(formSchema)

  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (!isBusy && formData.isValid()) {
      setIsBusy(true)

      try {
        if (attendee.id) {
          await updateAttendee({ id: attendee.id, eventId, ...formData.values })
        } else {
          await addNewAttendee({ eventId, ...formData.values })
        }

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        if (e.startsWith('An attendee with')) {
          newMessage({ message: e, severity: 'failure' })
        }
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const title = attendee.id ? 'Edit Attendee' : 'Add Attendee';

  const buttonText = attendee.id ? 'Edit Attendee' : 'Add Attendee';

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {buttonText}
      </Button>
    </div>
  )

  return (
    <Modal title={title} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div style={{
          display: 'flex'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='name'
            type='text'
            label='Full Name'
            placeholder='e.g. John Smith'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='email'
            type='text'
            label={isStarSubdomain ? 'School Email' : 'Email'}
            placeholder='e.g. jsmith@gmail.com'
            formData={formData}
          />
        </div>
        {
          isStarSubdomain &&
          <div style={{
            display: 'flex'
          }}>
            <FormField
              style={{ flex: 1 }}
              fieldId='date'
              type='date'
              label='Date'
              placeholder=''
              formData={formData}
            />
          </div>
        }
        {
          isStarSubdomain &&
          <div style={{
            display: 'flex'
          }}>
            <FormField
              style={{ flex: 1 }}
              fieldId='district'
              type='text'
              label='District'
              placeholder=''
              formData={formData}
            />
          </div>
        }
      </div>
    </Modal>
  )
}